import React, {useState, useEffect, useCallback, useRef} from 'react';
import { AppContext } from '../Contexts';
import { buscar } from '../Utils/Buscar';
import {REFRESH_APP_CONFIGURATION} from "../Utils";
export function AppProvider({children}) {
    const consultaActualId = useRef();
    const [configuration, setConfiguration] = useState(undefined);
    useEffect(() => {
        let onGetConfigError = (error) => {
            setCurrentConfiguration(null);
        };
        setTimeout(() => {
            const consultaId = Math.random();
            consultaActualId.current = consultaId;

            const url = REFRESH_APP_CONFIGURATION
            try {
                buscar(url, {}).then((data) => {
                    if (consultaId === consultaActualId.current) {
                        if(data) {
                            setConfiguration(data)
                        }
                    }
                }).catch((err) => {
                    onGetConfigError(err);

                })
            }catch (e) {
                onGetConfigError(e);
            }
        }, 100);
    }, []);

    const setCurrentConfiguration = useCallback(
        (data) => {
            setConfiguration(data || null);
        },
        [configuration]
    );

    return (
        <AppContext.Provider value={{configuration}}>
            <div id="appContainer" style={{fontFamily: (configuration?.Vendor === 'claro' ? 'AMX' : 'Roboto')}}>
                {children}
            </div>
        </AppContext.Provider>
    );
}
